'use client'

import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAdmin } from '@/hooks/useAdmin'
import { useAuth } from '@/hooks/useAuth'
import LoadingSpinner from '@/components/ui/LoadingSpinner'
import AdminDashboard from '@/components/admin/AdminDashboard'

export default function AdminPage() {
  const { user, isLoading: authLoading } = useAuth()
  const { isAdmin, loading: adminLoading } = useAdmin()
  const navigate = useNavigate()

  useEffect(() => {
    if (!authLoading && !user) {
      navigate('/auth/login')
    }
  }, [authLoading, user, navigate])

  if (authLoading || adminLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (!user || !isAdmin) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="max-w-md mx-auto text-center p-8 bg-card border border-border rounded-2xl shadow-lg">
          <h1 className="text-2xl font-bold text-foreground mb-3">Access denied</h1>
          <p className="text-muted-foreground">You do not have permission to view the admin panel.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="dark min-h-screen bg-background text-foreground">
      <AdminDashboard user={user} />
    </div>
  )
}


